var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.is_logged)?_c('menu-bar'):_vm._e(),_c('b-container',{staticStyle:{"margin-top":"70px"},attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }